const signIn = "authenticate";
const signUp = "register";
const testUser = "";
const testPassword = "";
const getUser = "User/";

export default {
  signIn,
  signUp,
  testUser,
  testPassword,
  getUser
};
